import React from 'react';
import styled from 'styled-components';
import data from '../Assets/data.json';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
    CalendarWeek,
    People,
    HourglassSplit,
    BarChartLine,
    EmojiAngry,
    GraphDown,
    Award,
    Briefcase,
    LifePreserver,
    Heart,
    PersonCheck,
    Flower1
} from 'react-bootstrap-icons';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5rem 0;
`;

const Container = styled.div`
  @media(max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  @media(min-width: 769px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    column-gap: 2rem;
    row-gap: 2rem;
    margin: 0 21%;
  }
  
  @media(max-height: 900px) and (min-width: 1024px) {
    margin: 0 15%;
  }
`;

const Title = styled.h2`
  font-weight: bolder;
  margin: 0 0 1.5rem 0;
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 3rem;
`;

const Text = styled.span`
  margin-left: 10px;
`;

const OfferSection = () => {
    return (
        <Wrapper id="offer-section">
            <Title>{data.offer.title}</Title>
            <Container>
                <Item>
                    <CalendarWeek size="1.5rem"/>
                    <Text>{data.offer.offers[1]}</Text>
                </Item>
                <Item>
                    <People size="1.5rem"/>
                    <Text>{data.offer.offers[2]}</Text>
                </Item>
                <Item>
                    <HourglassSplit size="1.5rem"/>
                    <Text>{data.offer.offers[3]}</Text>
                </Item>
                <Item>
                    <Briefcase size="1.5rem"/>
                    <Text>{data.offer.offers[4]}</Text>
                </Item>
                <Item>
                    <EmojiAngry size="1.5rem"/>
                    <Text>{data.offer.offers[5]}</Text>
                </Item>
                <Item>
                    <GraphDown size="1.5rem"/>
                    <Text>{data.offer.offers[6]}</Text>
                </Item>
                <Item>
                    <Award size="1.5rem"/>
                    <Text>{data.offer.offers[7]}</Text>
                </Item>
                <Item>
                    <BarChartLine size="1.5rem"/>
                    <Text>{data.offer.offers[8]}</Text>
                </Item>
                <Item>
                    <LifePreserver size="1.5rem"/>
                    <Text>{data.offer.offers[9]}</Text>
                </Item>
                <Item>
                    <Heart size="1.5rem"/>
                    <Text>{data.offer.offers[10]}</Text>
                </Item>
                <Item>
                    <PersonCheck size="1.5rem"/>
                    <Text>{data.offer.offers[11]}</Text>
                </Item>
                <Item>
                    <Flower1 size="1.5rem"/>
                    <Text>{data.offer.offers[12]}</Text>
                </Item>
            </Container>
        </Wrapper>
    );
};

export default OfferSection;
